import React from 'react'
import PropTypes from 'prop-types'
import classNames from 'classnames'
import undefsafe from 'undefsafe'
import queryString from 'query-string'
import { renderRoutes } from 'react-router-config'

import SiteHeader from '../components/siteHeader'
import SiteFooter from '../components/footer/siteFooter'
import CrossSellLinksFooter from '../components/crossSellLinksFooter'
import PageOverlay from '../components/pageOverlay'
import PageOffCanvasLeft from '../components/pageOffCanvasLeft'
import PageOffCanvasRight from '../components/pageOffCanvasRight'
import SiteMeta from '../components/siteMeta/siteMeta'
import Modal from '../components/modals/'

import SearchOfflinePage from './searchOfflinePage'
import NotFoundContainer from './notFoundContainer'
import OldIE from '../../server/template/oldIE'
import { getCurrentSiteDomain } from '../../common/utils/sites'
import siteConfigs from '../../config/sites'

class App extends React.Component {
  static propTypes = {
    pageIsOffCanvas: PropTypes.bool.isRequired,
    pageCanvasDirection: PropTypes.string,
    stats: PropTypes.object,
    toggleOffCanvas: PropTypes.func.isRequired,
    seoMeta: PropTypes.object.isRequired,
    menuConfig: PropTypes.array.isRequired,
    errorPage: PropTypes.any,
    noIndex: PropTypes.bool,
    banners: PropTypes.array.isRequired
  }

  toggleOffCanvas (direction) {
    this.props.toggleOffCanvas(direction)
  }

  componentDidMount () {
    const fastclick = require('fastclick')
    const { initUser } = this.props

    fastclick.attach(document.body)

    // init user and load user preference
    initUser()
  }

  renderContent () {
    const {
      errorPage,
      location,
      currentSite,
      route
    } = this.props

    // add query back to location object
    location.query = queryString.parse(location.search)

    const popularFilesUrl = `//${getCurrentSiteDomain(currentSite)}/page/top_sellers`
    const siteDisplayName = undefsafe(siteConfigs, `${currentSite}.name`) || currentSite

    switch (errorPage) {
      case 'NotFoundContainer':
        return (<NotFoundContainer
          location={location}
        />)

      case 'SearchOffline':
        return (<SearchOfflinePage
          popularFilesUrl={popularFilesUrl}
          siteDisplayName={siteDisplayName}
        />)

      default:
        return renderRoutes(route.routes)
    }
  }

  render () {
    const {
      user,
      pageIsOffCanvas,
      pageCanvasDirection,
      stats,
      currentSite,
      seoMeta,
      location,
      baseUrl,
      menuConfig,
      noIndex,
      isModalOpen,
      closeModal,
      openModalType,
      openModalData,
      banners
    } = this.props

    // add query back to location object
    // TODO: fetch from redux store instead of `withRouter`
    location.query = queryString.parse(location.search)

    let isOffCanvasActive = pageIsOffCanvas
    let showLeftOffCanvas = isOffCanvasActive && pageCanvasDirection === 'left'
    let showRightOffCanvas = isOffCanvasActive && pageCanvasDirection === 'right'

    let pageClass = classNames('page', {
      'page--is-off-canvas': isOffCanvasActive
    })
    let pageCanvasClass = classNames('page__canvas', {
      'page__canvas--is-off-canvas-left': showLeftOffCanvas,
      'page__canvas--is-off-canvas-right': showRightOffCanvas
    })

    return (
      <div className={pageClass}>
        <OldIE siteName={currentSite} />
        <SiteMeta
          seoMeta={seoMeta}
          location={location}
          currentSite={currentSite}
          noIndex={noIndex}
          baseUrl={baseUrl}
        />

        <Modal
          closeModal={closeModal}
          isModalOpen={isModalOpen}
          openModalType={openModalType}
          openModalData={openModalData}
        />

        <PageOffCanvasLeft
          showLeftOffCanvas={showLeftOffCanvas}
          currentSite={currentSite}
          menuConfig={menuConfig}
          location={location}
        />
        <PageOffCanvasRight
          user={user}
          currentSite={currentSite}
          showRightOffCanvas={showRightOffCanvas}
        />
        <div className={pageCanvasClass}>
          <div className='canvas'>
            <SiteHeader user={user}
              currentSite={currentSite}
              toggleOffCanvas={this.toggleOffCanvas.bind(this)}
              menuConfig={menuConfig}
              banners={banners} />

            {this.renderContent()}

            <CrossSellLinksFooter currentSite={currentSite} />
            <SiteFooter
              currentSite={currentSite}
              stats={stats}
              location={location}
            />
            <PageOverlay
              isOffCanvasActive={isOffCanvasActive}
              toggleOffCanvas={this.toggleOffCanvas.bind(this)}
            />
          </div>
        </div>
      </div>
    )
  }
}

export default App



// WEBPACK FOOTER //
// ./client/pages/app.js